/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OnboardResponse } from './OnboardResponse';
import {
    OnboardResponseFromJSON,
    OnboardResponseFromJSONTyped,
    OnboardResponseToJSON,
} from './OnboardResponse';

/**
 * 
 * @export
 * @interface SuccessResponseOnboardResponse
 */
export interface SuccessResponseOnboardResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SuccessResponseOnboardResponse
     */
    status?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponseOnboardResponse
     */
    timeStamp?: string;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponseOnboardResponse
     */
    message?: SuccessResponseOnboardResponseMessageEnum;
    /**
     * 
     * @type {OnboardResponse}
     * @memberof SuccessResponseOnboardResponse
     */
    data?: OnboardResponse;
}


/**
 * @export
 */
export const SuccessResponseOnboardResponseMessageEnum = {
    UserSignedUp: 'USER_SIGNED_UP',
    UserConfirmed: 'USER_CONFIRMED',
    UserComplete: 'USER_COMPLETE',
    WalletSaved: 'WALLET_SAVED',
    AlreadyConfirmed: 'ALREADY_CONFIRMED',
    AlreadyOnboarded: 'ALREADY_ONBOARDED',
    ResentConfirmationCode: 'RESENT_CONFIRMATION_CODE',
    Ok: 'OK'
} as const;
export type SuccessResponseOnboardResponseMessageEnum = typeof SuccessResponseOnboardResponseMessageEnum[keyof typeof SuccessResponseOnboardResponseMessageEnum];


/**
 * Check if a given object implements the SuccessResponseOnboardResponse interface.
 */
export function instanceOfSuccessResponseOnboardResponse(value: object): boolean {
    return true;
}

export function SuccessResponseOnboardResponseFromJSON(json: any): SuccessResponseOnboardResponse {
    return SuccessResponseOnboardResponseFromJSONTyped(json, false);
}

export function SuccessResponseOnboardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuccessResponseOnboardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'timeStamp': json['timeStamp'] == null ? undefined : json['timeStamp'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OnboardResponseFromJSON(json['data']),
    };
}

export function SuccessResponseOnboardResponseToJSON(value?: SuccessResponseOnboardResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'timeStamp': value['timeStamp'],
        'message': value['message'],
        'data': OnboardResponseToJSON(value['data']),
    };
}

